import '/assets/styles/sections/menu-header.scss';
import classNames from 'classnames';

// Context
import { useBranchSelection } from '/utilities/branch-selection';
import { useNavigator } from '@wearetla/tla-essentials-tools/utilities/navigator';
import { useTranslation } from '/utilities/i18n';

// Partials
import { Input } from '/views/partials/forms';
import Btn from '/views/partials/btn';

// Sections
import PageHeader from '/views/sections/page-header';

const MenuHeader = ({
	searchValue,
	onSearchValueChange,
	backLinkRedirect,
	backLinkFallback,
	backLinkParams,
	backLink,
	hideSearch,
	autoFocus,
	title,
}) => {
	const { branchTableTitle } = useBranchSelection();
	const { redirect } = useNavigator();
	const { t } = useTranslation();
	const resolvedTitle = title ?? t('Menü');

	return (
		<div className="section menu-header">
			<PageHeader
				icon="menu"
				backLink={backLink ?? 'home'}
				backLinkParams={backLinkParams}
				backLinkRedirect={backLinkRedirect}
				backLinkFallback={backLinkFallback}
				title={resolvedTitle}
				backLinkText
				subtitle={branchTableTitle}
			/>
			{!hideSearch && (
				<div className="header-search">
					<div className="wrapper">
						<Input
							autoFocus={!!searchValue || autoFocus}
							icon="search"
							placeholder={t('Ne yemek istersin?')}
							type="text"
							innerContent={
								!!searchValue && (
									<Btn
										icon="close"
										onClick={() => {
											onSearchValueChange('');
										}}
										className={classNames('header-clearbtn', 'rounded', {
											show: !!searchValue?.length,
										})}
										title={t('Temizle')}
									/>
								)
							}
							value={searchValue}
							onChange={onSearchValueChange}
							onClick={
								onSearchValueChange
									? undefined
									: () => {
											redirect('menuSearch');
										}
							}
						/>
					</div>
				</div>
			)}
		</div>
	);
};

export default MenuHeader;
